import { render, staticRenderFns } from "./roleAdmin.vue?vue&type=template&id=85bb71bc&scoped=true"
import script from "./roleAdmin.vue?vue&type=script&lang=js"
export * from "./roleAdmin.vue?vue&type=script&lang=js"
import style0 from "./roleAdmin.vue?vue&type=style&index=0&id=85bb71bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bb71bc",
  null
  
)

export default component.exports